import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as moment from 'moment';


const generatePDF = (title, headers, data, filename, options = {}) => {
  const { format = 'a4' } = options; // default a 'a4' si no se especifica

  const doc = new jsPDF({
    orientation: 'landscape',
    format,
  });

  doc.text(title, 14, 10);

  // Quita 'format' del options antes de pasarlo a autoTable
  const { format: _, ...autoTableOptions } = options;

  autoTable(doc, {
    head: headers,
    body: data,
    startY: 20,
    theme: 'grid',
    styles: { fontSize: 10 },
    headStyles: { fillColor: [200, 200, 200] },
    ...autoTableOptions,
  });

  doc.save(filename);
};

export const generateSchoolPDF = (user) => {
  const headers = [
    [
      'Fecha de registro', 
      'Nombre', 
      'ID del CE', 
      'Nombre del director', 
      'Telefono institucional', 
      'Correo', 
      `Estatus\nSuscripción`,
      `Fecha\nVencimiento`,
      'Estatus'
    ]
  ];

  const data = user.map((item) => [
    moment(item?.created_at).format('DD-MM-YYYY'),
    item?.fullname,
    item?.dea_code,
    item?.director,
    item?.phonecode?.name + item?.phone,
    item?.email,
    item?.last_plan_user ? moment(item?.last_plan_user?.next_payment).isBefore(moment(), 'day') ? "Vencida" : "Vigente" : "Sin suscripción",
    item?.last_plan_user ? moment(item?.last_plan_user?.next_payment).format('DD-MM-YYYY') : '-',
    item?.status_text
  ]);

  generatePDF('Reporte de centros educativos', headers, data, 'centros educativos.pdf');
};

export const generateTeacherPDF = (user) => {
  const headers = [
    [
      'Fecha de registro', 
      'Nombre', 
      'DNI/C.I', 
      'Telefono', 
      'Correo', 
      'Nacionalidad', 
      'Materias que dicta', 
      'CE donde labora', 
      `Estatus\nSuscripción`,
      `Fecha\nVencimiento`,
      'Estatus'
    ]
  ];

  const data = user.map((item) => [
    moment(item?.created_at).format('DD-MM-YYYY'),
    item?.fullname,
    item?.document_type?.name + item?.document,
    item?.phonecode?.name + item?.phone,
    item?.email,
    item?.country?.name,
    (item?.subjects?.map(x => x?.subject?.name)).join(', '),
    item?.school?.name,
    item?.last_plan_user ? moment(item?.last_plan_user?.next_payment).isBefore(moment(), 'day') ? "Vencida" : "Vigente" : "Sin suscripción",
    item?.last_plan_user ? moment(item?.last_plan_user?.next_payment).format('DD-MM-YYYY') : '-',
    item?.status_text
  ]);

  const options = {
    format: 'a3', // <--- SOLO aquí
    columnStyles: {
      0: { cellWidth: 28 },
      1: { cellWidth: 40 },
      2: { cellWidth: 28 },
      3: { cellWidth: 35 },
      4: { cellWidth: 40 },
      5: { cellWidth: 28 },
      6: { cellWidth: 35 },
      7: { cellWidth: 32 },
      8: { cellWidth: 46 },
      9: { cellWidth: 40 },
      10: { cellWidth: 28 },
    },
    styles: { fontSize: 10, cellPadding: 2 },
    headStyles: { fontSize: 10, fillColor: [200, 200, 200] }
  };

  generatePDF('Reporte de profesores', headers, data, 'profesores.pdf', options);
};


export const generateParentPDF = (user) => {
  const headers = [
    ['Nombre', 'DNI/C.I', 'Teléfono', 'Correo', 'Genero', 'Nacionalidad', 'Fech. Nacimiento', 'Estado civil', 'Representados', 'Estatus']
  ]

  const data = user.map((item) => [
    item?.fullname,
    item?.document_type?.name + item?.document,
    item?.phonecode?.name + item?.phone,
    item?.email,
    item?.gender?.name,
    item?.country?.name,
    moment(item?.birthdate).format('DD-MM-YYYY'),
    item?.civil_status?.name,
    item?.represented?.map(item => item?.student?.fullname),
    item?.status_text
  ]);

  generatePDF('Reporte de padres o represetantes', headers, data, 'representantes.pdf');
}